/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import { Img } from 'react-image';

import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import {
  Box, Grid, Typography, CircularProgress,
} from '@material-ui/core';
import moment from 'moment';

import { styles } from '../style';

const useStyles = makeStyles(styles);

export default function ForecastRainfallCompare() {
  const { t } = useTranslation();
  const classes = useStyles();
  const hostApi = `${process.env.REACT_APP_API_URL}`;

  const [isLoading, setLoading] = useState(false);
  const [hasError, sethasError] = useState();
  const [image, setImage] = useState([]);
  // https://hpc.tmd.go.th/static/images/idv/2021080312/d01/preci24hr/202108050000Z_Rain%20Daily.png
  const tmdHost = 'https://hpc.tmd.go.th/static/imgDA';
  const placeHolder = 'https://via.placeholder.com/322x230?text=No%20Image&italic=true';

  useEffect(() => {
    async function getData() {
      setLoading(true);
      await fetch(`${hostApi}/public/rain7day_forecast`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Something went wrong ...');
        })
        .then((data) => {
          const tmp = [];

          // ภาพ WRF จาก TMD เงื่อนไขการแสดงผล
          // 3 วันแรก เป็น domain 2 / วันที่ 4 -7  เป็น domain 1
          // เวลา 19.00-06.00น. ใช้ข้อมูล 00UTC
          // เวลา 07.00-18.00น.  ใข้ข้อมูล 12UTC
          // รายละเอียดติดต่อเบส นน.
          let domain = 'd01';
          const currentDate = moment().format('YYYY-MM-DD');
          const currentHour = moment().format('H');
          let folderHour = '_0000';
          let firstDate = moment(currentDate);
          let dateForFolder = currentDate;
          if (currentHour >= 7 && currentHour <= 18) {
            folderHour = '_1200';
            firstDate = moment(currentDate).format('YYYY-MM-DD');
            dateForFolder = moment(currentDate).subtract(1, 'days').format('YYYYMMDD');
          }
          const folderDate = `${dateForFolder}${folderHour}`;
          let tmdDate = '';
          for (let i = 0; i < data.data.pre_rain_sea.data.length; i += 1) {
            tmdDate = moment(new Date(firstDate)).add((i), 'days').format('YYYYMMDD');
            const tmdLink = `${tmdHost}/${folderDate}/${domain}/p24h/p24h.${tmdDate}0000.${domain}.png`;
            tmp.push({
              media_path_hii: `${hostApi}/shared/image?_csrf=&image=${data.data.pre_rain_sea.data[i].media_path}`,
              media_path_tmd: tmdLink,
              media_datetime: data.data.pre_rain_sea.data[i].media_datetime,
            });
          }
          setImage(tmp);
          setLoading(false);
        })
        .catch(() => { sethasError(true); });
    }
    getData();
  }, [hostApi]);
  return (
    <>
      {hasError && (
        <div>
          Error Occured
        </div>
      )}
      {isLoading && (
        <div className="Loading">
          <CircularProgress />
        </div>
      )}
      <div className={classes.root}>
        <Grid container spacing={2}>
          <Grid item>
            <Typography className={classes.titleSub}>
              {t('เปรียบเทียบ แผนภาพคาดการณ์ฝน WRF-ROMS Model กับ TMD-WRF Model')}
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={3}>

          <Box display="block">
            {image.map((img, index) => (
              <Grid item key={index} style={{ marginTop: 30 }}>
                <Box className={classes.titleThirdBox}>{moment(img.media_datetime).format('ll')}</Box>
                <Box className={classes.bodyBox} style={{ flexDirection: 'row', alignItems: 'flex-start' }}>
                  <Grid container spacing={3} alignItems="center">
                    <Grid
                      item
                      md
                      key={`${index}content`}
                      style={{
                        minHeight: '100vh',
                      }}
                    >
                      <Img
                        src={img.media_path_hii}
                        alt={img.media_datetime}
                        className={classes.img}
                        style={{ width: '100%' }}
                        unloader={(
                          <Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />
                        )}
                      />
                    </Grid>
                    <Grid
                      item
                      md
                      style={{
                        minHeight: '100vh',
                      }}
                    >
                      <Img
                        src={img.media_path_tmd}
                        alt={img.media_datetime}
                        className={classes.img}
                        style={{ width: '100%' }}
                        unloader={(
                          <Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />
                        )}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item>
                      <Typography variant="body2">
                        *
                        {' '}
                        {t('โดยทั่วไปความแม่นยำของการคาดการณ์สภาวะฝนจะลดลงเมื่อระยะเวลาคาดการณ์ยาวขึ้น โดยจะมีความแม่นยำสูงสุดที่ 3 วันข้างหน้า โปรดใช้วิจารณญาณในการนำข้อมูลไปใช้')}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            ))}
          </Box>
        </Grid>
      </div>
    </>
  );
}
